import Support from '../../utils/support';

export default {
  name: 'support',
  proto: {
    support: Support,
  },
  static: {
    support: Support,
  },
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/framework7/components/swiper/swiper-class/modules/support/support.js
// module id = null
// module chunks = 